import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class NumberControl extends ExtendedFormControl {
    readonly inputType = 'number';

    constructor(name: string, value: string = '', validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
